<template>
    <nav id="sidebar">
    </nav>
</template>

<script>
    export default {
        name: "SidebarServiceComponent"
    }
</script>

<style lang="scss" scoped>
    nav#sidebar {
        width: 250px;
        position: fixed;
        top: 48px;
        bottom: 0;
        left: 0;
        z-index: 100;
        background-color: black;

        li.nav-item a.nav-link {
            font-size: .85em;
            padding: .75rem 1rem;

            -webkit-transition: background-color .467s cubic-bezier(.1, .9, .2, 1) 34ms;
            -moz-transition: background-color .467s cubic-bezier(.1, .9, .2, 1) 34ms;
            -ms-transition: background-color .467s cubic-bezier(.1, .9, .2, 1) 34ms;
            -o-transition: background-color .467s cubic-bezier(.1, .9, .2, 1) 34ms;
            transition: background-color .467s cubic-bezier(.1, .9, .2, 1) 34ms;

            &.active {
                background-color: #760000;
                color: var(--white);
            }

            &:not(.active):hover {
                background-color: rgba(0,0,0,.25);
            }
        }
    }


    nav#sidebar li.nav-item a.nav-link > svg {
        margin-right: 10px;
    }
</style>